import {Component} from "@angular/core";
import {ViewController, Events, NavParams} from "ionic-angular";
import {UserService} from "../../../pages/shared/user/user.service";

@Component({
  templateUrl: 'colleague-search-modal.component.html',
})
export class ColleagueSearchModal{
  colleagues: any[];

  constructor(private viewCtrl: ViewController,
              private events: Events,
              private userService: UserService,
              private navParams: NavParams
  ) {
  }

  dismiss() {
    return this.viewCtrl.dismiss();
  }

  selectColleague(colleague){
    let event = this.navParams.get('event') || 'publisher:selected';
    this.events.publish(event, colleague);
    this.dismiss();
  }

  getColleagues(ev: any){
    let val = ev.target.value;
    if(!val || val.trim() === ''){
      return;
    }

    this.userService.getColleagues(val)
      .subscribe(users => {
        this.colleagues = users;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/colleague-search-modal/colleague-search-modal.component.ts